import { FORGE_MODULE_GLOBAL_PAGE } from '@confluence/forge-ui/entry-points/ForgeModuleType.ts';
import { SYSTEM_HEADER_LEFT } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

import { SPACES_KEY, PEOPLE_KEY, DISCOVER_KEY, AUTOMATION_KEY } from './appKeys.ts';

export const getGlobalAppsParams = ({ edition, accessStatus }) => {
	const isAdmin = accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;
	const hideAutomation = edition !== 'PREMIUM' || !isAdmin;

	const notAllowedWebItems = [
		SPACES_KEY,
		PEOPLE_KEY,
		DISCOVER_KEY,
		hideAutomation ? AUTOMATION_KEY : '',
	];

	return {
		webItemParams: {
			location: SYSTEM_HEADER_LEFT,
			notAllowedWebItems,
		},
		forgeExtensionParams: {
			moduleType: FORGE_MODULE_GLOBAL_PAGE,
			spaceKey: '',
		},
	};
};
